import axios from "@/api/axiosInstance";
import {
  FetchKPIOverviewCoachesRequest,
  FetchKPIOverviewCoachesResponse,
  KPIOverviewCoachesResult,
} from "./types";

export const fetchKPIOverviewCoaches = async (
  params: FetchKPIOverviewCoachesRequest,
): Promise<KPIOverviewCoachesResult> => {
  const response = await axios.get<FetchKPIOverviewCoachesResponse>(
    "/api/private/admin/kpi-overview/coaches",
    { params },
  );
  return {
    data: response.data.data,
    totalCount: response.data.meta?.totalCount ?? 0,
  };
};
